import { defineStore } from 'pinia'
import { getSysName, type BeianInfo } from '@/api/vis'
import { login, type LoginParams } from '@/api/login'
import { getLoginUserDetail, getAllDictList } from '@/api/common'
import type { UserInfo } from '@/api/modules/systemManage/user'
import { removeToken, setToken } from '@/utils/token'
import { localDicts } from '@/utils/localDicts'
import type { DictType2dicts } from '@shared/dict'
interface AppState {
	platformTitle: string
	beianInfo: BeianInfo | null
	token: string
	userInfo: UserInfo | Recordable<any>
	menus: Recordable<any>[]
	dictType2dicts: DictType2dicts
}
export const useAppStore = defineStore({
	id: 'app',
	state: (): AppState => ({
		platformTitle: '', // 平台的 title
		beianInfo: null,
		token: '',
		userInfo: {
			userHeadFile: [],
		},
		menus: [],
		dictType2dicts: {},
	}),
	getters: {
		sysNameOfCn(): string {
			return this.platformTitle || '康复师X'
		},
		userId(): IdType {
			return this.userInfo?.userId
		},
	},
	actions: {
		async getSysName() {
			const { sctName } = await getSysName()
			this.platformTitle = sctName
		},
		async login(params: LoginParams) {
			const { token } = await login(params)
			this.token = token
			setToken(token)
		},
		async logout() {
			this.token = ''
			this.userInfo = {}
			removeToken()
			// 动态导入以避免循环引用
			const { resetRouter } = await import('@/router/index')
			resetRouter()
		},
		async getLoginUserDetail() {
			const userInfo = await getLoginUserDetail()
			this.userInfo = userInfo
		},
		async getAllDictList() {
			const dictType2dicts = await getAllDictList()
			this.dictType2dicts = { ...localDicts, ...dictType2dicts }
		},
		isUser(userId: IdType): boolean {
			return this.userInfo?.userId === userId
		},
	},
})
